// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.app-components-MenuItem-___MenuItem-module__container {
  font-size: 16px;
  padding: 5px 15px;
}

  .app-components-MenuItem-___MenuItem-module__container:hover {
    box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.1) inset;
  }

  .app-components-MenuItem-___MenuItem-module__container:focus {
    box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.2) inset;
  }
`, "",{"version":3,"sources":["webpack://./app/components/MenuItem/MenuItem.module.scss"],"names":[],"mappings":"AAAA;EACE,eAAe;EACf,iBAAiB;AAQnB;;EANE;IACE,iDAAiD;EACnD;;EACA;IACE,iDAAiD;EACnD","sourcesContent":[".container {\n  font-size: 16px;\n  padding: 5px 15px;\n\n  &:hover {\n    box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.1) inset;\n  }\n  &:focus {\n    box-shadow: 0 0 0 1000px rgba(0, 0, 0, 0.2) inset;\n  }\n}\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `app-components-MenuItem-___MenuItem-module__container`
};
export default ___CSS_LOADER_EXPORT___;
